import { render } from "./EditLiquidation3.vue?vue&type=template&id=3c763504"
import script from "./EditLiquidation3.vue?vue&type=script&lang=js"
export * from "./EditLiquidation3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__